export default "__VITE_ASSET__CjMn4K6h__"